import React from 'react'
import About from './components/About'
import Contact from './components/Contact'
import Footer from './components/Footer'
import Header from './components/Header'
import Navbar from './components/Navbar'
import Projects from './components/Projects'
import Services from './components/Services'
import Stacks from './components/Stacks'

function App() {
  return (
    <div className='content'>
      <Navbar/>
      <Header/>
      <Services/>
      <About/>
      <Stacks/>
      <Projects/>
      <Contact/>
      <Footer/>
    </div>
  )
}

export default App